/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import request from '@/utils/http';

export default {
    customerOrderNoCode: {
        'name': '请输入承运商',
        'advanceLabel': '承运商',
        'value': 'carrierName',
        'advanceConfig': [
            { 'prop': 'supplierNameCn', 'value': '承运商名称' },
            { 'prop': 'supplierCode', 'value': '承运商编码' }
        ],
        'tableConfig': [
            { 'prop': 'supplierNameCn', 'value': '承运商名称' },
            { 'prop': 'supplierCode', 'value': '承运商编码' },
            { 'prop': 'transNameListStr', 'value': '采购渠道' }
        ],
        advanceNotSearch: true,
        queryConditionRequired: true,
        method: 'post',
        advanceUrl: 'srm/supplier/search',
        prefix: '/api-tms/',
        'cbParams': [
            'supplierNameCn#carrierName', 'supplierCode#supplierCode', 'transTypeListStr#transType', 'transNameListStr#tranName', 'supplierCode#carrierCode', 'propertyNature'
        ],
        advanceCascade: 'professionalCompanyList,siteCodeList,supplierStatus,businessTypeStatus'
    },
    // 车牌
    vehicleCardLists: {
        'method': 'post',
        'name': '来源：已注册运力',
        'advanceLabel': '车牌号',
        'value': 'vehicleCard',
        'advanceConfig': [
            { 'prop': 'licensePlateNo', 'value': '车牌' },
            { 'prop': 'maxVolume', 'value': '载货体积' },
            { 'prop': 'carTypeNameCn', 'value': '车型' },
            { 'prop': 'carType', 'value': '车型编码' }
        ],
        'tableConfig': [
            { 'prop': 'licensePlateNo', 'value': '车牌' },
            { 'prop': 'maxVolume', 'value': '载货体积' },
            { 'prop': 'carTypeNameCn', 'value': '车型' },
            { 'prop': 'carType', 'value': '车型编码' }
        ],
        'cbParams': [
            'licensePlateNo#vehicleCard',
            'maxVolume#cargoVolumeStr',
            'carTypeNameCn#equipmentName',
            'carType#equipmentType',
            'deviceNo'
        ],
        'prefix': '/api-srm-web/',
        'advanceUrl': 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
        'advanceCascade': 'supplierCode,routeNoList'
    },
     // 车牌
    controlVehicleCardLists: {
        method: 'post',
        name: '请输入车牌号',
        advanceLabel: '车牌号',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', value: '车牌' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        cbParams: ['licensePlateNo#vehicleCard', 'maxVolume#cargoVolumeStr', 'carTypeNameCn#equipmentName', 'carType#equipmentType', 'deviceNo'],
        prefix: '/api-tms/',
        advanceUrl: '/dispatch/resource/car/query',
        advanceCascade: 'supplierCode,siteCodeList,checkResource'
    },
    // 司机
    controlDriverLists: {
        method: 'post',
        name: '请输入司机',
        advanceLabel: '司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        tableConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        prefix: '/api-tms/',
        advanceUrl: 'dispatch/resource/driver/query',
        cbParams: ['driverName#driver', 'driverPhone#driverContactWay', 'driverIdCard#driverIdentity', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'driverCode#driverNo'],
        advanceCascade: 'supplierCode,siteCodeList,checkResource'
    },
    // LSP车牌
    LSPVehicleCardLists: {
        method: 'post',
        name: '来源：专线零担运力',
        advanceLabel: '选择车牌',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', 'value': '车牌' },
            { prop: 'carType', 'value': '车型代码' },
            { prop: 'carTypeNameCn', 'value': '车型' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', 'value': '车牌' },
            { prop: 'carTypeNameCn', 'value': '车型' },
            { prop: 'carType', 'value': '车型代码' }
        ],
        cbParams: [
            'licensePlateNo#vehicleCard',
            'carTypeNameCn#equipmentName',
            'carType#equipmentType'
        ],
        paramType: true,
        prefix: '/api-antms/lsp',
        advanceUrl: '/vehicle/info/page',
        advanceCascade: 'supplierCode'
    },
    // 司机
    driverLists: {
        'method': 'post',
        'name': '来源：已注册运力',
        'advanceLabel': '司机',
        'value': 'driver',
        'advanceConfig': [
            { 'prop': 'driverName', 'value': '司机' },
            { 'prop': 'driverPhone', 'value': '电话' },
            { 'prop': 'driverCode', 'value': 'DN编码' },
            { 'prop': 'driverIdCard', 'value': '身份证号' }

        ],
        'tableConfig': [
            { 'prop': 'driverName', 'value': '司机' },
            { 'prop': 'driverPhone', 'value': '电话' },
            { 'prop': 'driverCode', 'value': 'DN编码' },
            { 'prop': 'driverIdCard', 'value': '身份证号' }
        ],
        'prefix': '/api-srm-web/',
        'advanceUrl': 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
        'cbParams': [
            'driverName#driver',
            'driverPhone#driverContactWay',
            'driverIdCard#driverIdentity',
            'onWayContactCategory',
            'onWayContactName',
            'onWayContactPhone',
            'driverCode#driverNo'
        ],
        'advanceCascade': 'supplierCode,routeNoList'
    },
    // LSP司机
    LSPDriverLists: {
        method: 'post',
        name: '来源：专线零担运力',
        advanceLabel: '选择司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', 'value': '司机' },
            { prop: 'driverPhone', 'value': '手机号码' },
            { prop: 'driverIdCard', 'value': '身份证号码' }

        ],
        tableConfig: [
            { prop: 'driverName', 'value': '司机' },
            { prop: 'driverPhone', 'value': '手机号码' },
            { prop: 'driverIdCard', 'value': '身份证号码' }
        ],
        paramType: true,
        prefix: '/api-antms/lsp',
        advanceUrl: '/driver/info/page',
        cbParams: [
            'driverName#driver',
            'driverPhone#driverContactWay',
            'driverIdCard#driverIdentity'
        ],
        advanceCascade: 'supplierCode'
    },
    // 税率
    taxRateLists: {
        'name': '请输入税率',
        'advanceLabel': '税率',
        'value': 'taxRate',
        'advanceConfig': [
            { 'prop': 'percentageRateStr', 'value': '税率百分比' },
            { 'prop': 'taxRateCode', 'value': '税率代码' }

        ],
        'tableConfig': [
            { 'prop': 'percentageRate', 'value': '税率百分比' },
            { 'prop': 'taxRateCode', 'value': '税率代码' }
        ],
        'advanceUrl': 'efTaxRate/popTaxRate/in',
        'cbParams': [
            'percentageRate#taxRate'
        ]
    },
    // 班次
    vehicleScheduleNames: {
        name: '班次',
        value: 'vehicleScheduleName',
        type: 'advance',
        dialogWidth: '900px',
        advanceConfig: [
            { prop: 'vehicleScheduleName', value: '班次名称' },
            { prop: 'vehicleScheduleCode', value: '班次编码' }
        ],
        tableConfig: [
            { prop: 'vehicleScheduleCode', value: '班次编码' },
            { prop: 'vehicleScheduleName', value: '班次名称' },
            { prop: 'senderCodeName', value: '发货地', width: '200px' },
            { prop: 'receiverCodeName', value: '收货地', width: '200px' },
            { prop: 'bcArrivalTime', value: '应到车时间' },
            { prop: 'bcDepartTime', value: '应发车时间' },
            { prop: 'bcArriveTime', value: '应抵达时间' }
        ],
        advanceUrl: 'vehicleScheduleRules/timeLimit',
        cbParams: ['vehicleScheduleCode', 'vehicleScheduleName', 'bcArriveTime',
            'bcDepartTime', 'bcArrivalTime', 'senderCodeName', 'receiverCodeName'],
        prefix: '/api-otp/',
        method: 'post',
        advanceCascade: 'companyCode'
    },
    whNames: {
        name: '提货仓',
        value: 'whName',
        type: 'advance',
        multiple: true,
        border: true,
        dialogWidth: '800px',
        advanceCode: 'cdwhName',
        multipleTableColumn:
        { prop: 'cdwhName', 'value': '仓库名称' },
        advanceConfig: [
            { 'prop': 'cdwhName', 'value': '仓库名称' },
            { 'prop': 'whCode', 'value': '仓库编码' }
        ],
        tableConfig: [
            { 'prop': 'whCode', 'value': '仓库编码', 'width': '200px' },
            { 'prop': 'cdwhName', 'value': '仓库名称' }
        ],
        advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
        cbParams: [
            'whCode', 'cdwhName#whName'
        ]
    },
    // 在途联系人
    onWayContactName: {
        method: 'post',
        name: '请输入在途联系人',
        advanceLabel: '在途联系人',
        value: 'contacts',
        rule: {
            validate: (formData) => {
                return new Promise((resolve, reject) => {
                    const url = '/api-tms/srm/onWayContact/queryPage';
                    request({
                        url,
                        method: 'post',
                        data: {
                            supplierCode: formData.supplierCode,
                            pageNo: '1',
                            pageSize: '10'
                        }
                    }).then(res => {
                        if (res.data.list.length > 0) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    });
                });
            },
            message: '请到LSRM-供应商主数据（联系人信息）维护对应信息，或者将“在途联系人类别”切换为司机”',
            async: true
        },
        advanceConfig: [
            { prop: 'contacts', value: '在途联系人' },
            { prop: 'contactsMobile', value: '电话' }
        ],
        tableConfig: [
            { prop: 'contacts', value: '在途联系人' },
            { prop: 'contactsMobile', value: '电话' }
        ],
        prefix: '/api-tms/',
        advanceUrl: 'srm/onWayContact/queryPage',
        cbParams: ['contacts', 'contactsMobile#onWayContactPhone'],
        advanceCascade: 'supplierCode,checkResource'
    },
    driverConfig: {
        method: 'post',
        name: '司机',
        advanceLabel: '选择司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', 'value': '司机' },
            { prop: 'driverPhone', 'value': '手机号' },
            { prop: 'driverIdCard', 'value': '身份证号码' }

        ],
        tableConfig: [
            { 'prop': 'driverName', 'value': '司机' },
            { 'prop': 'driverPhone', 'value': '手机号' },
            { 'prop': 'driverIdCard', 'value': '身份证号码' }
        ],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
        cbParams: [
            'driverName#driver',
            'driverPhone#driverContactWay',
            'driverIdCard#driverIdentity'
        ],
        advanceCascade: 'supplierCode,routeNoList'
    },
    vehicleCardConfig: {
        method: 'post',
        name: '车牌',
        advanceLabel: '选择车牌',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', 'value': '车牌' },
            { prop: 'carType', 'value': '车型代码' },
            { prop: 'carTypeNameCn', 'value': '车型' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', 'value': '车牌' },
            { prop: 'carType', 'value': '车型代码' },
            { prop: 'carTypeNameCn', 'value': '车型' }
        ],
        cbParams: [
            'licensePlateNo#vehicleCard',
            'carTypeNameCn#equipmentName',
            'carType#equipmentType'
        ],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
        advanceCascade: 'supplierCode,routeNoList'
    },
    AdmittRules: {
        carrierName: [
            {
                required: true,
                message: '承运商不能为空',
                trigger: ['blur', 'change']
            }
        ],
        shippingType: [
            {
                required: true,
                message: '发运类型不能为空',
                trigger: ['change']
            }
        ],
        vehicleCard: [
            {
                required: true,
                message: '车牌不能为空',
                trigger: ['blur', 'change']
            }
        ],
        conveniently: [
            {
                required: true,
                message: '是否顺路带回不能为空',
                trigger: 'blur'
            }
        ],
        procurementChannel: [
            {
                required: true,
                message: '采购渠道不能为空',
                trigger: ['blur', 'change']
            }
        ],
        driver: [
            {
                required: true,
                message: '司机不能为空',
                trigger: ['blur', 'change']
            }
        ],
        transportationCost: [
            {
                required: true,
                message: '运输成本不能为空',
                trigger: 'blur'
            },
            {
                pattern: /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|!0.0|!0.00|!0)$/,
                message:
                    '仅可输入数字，不能为0，支持小数点后2位；包含小数点共9位',
                trigger: 'blur'
            }
        ],
        oilcardPayAmount: [
            {
                pattern: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])|(0\.[1-9]\d*)$/,
                message: '数值必须大于0',
                trigger: 'blur'
            }
        ],
        taxRate: [
            {
                required: true,
                message: '税率不能为空',
                trigger: 'blur'
            }
        ],
        onWayContactCategory: [
            {
                required: true,
                message: '请选择在途联系类别',
                trigger: 'change'
            }
        ],
        onWayContactName: [
            {
                required: true,
                message: '请输入在途联系人',
                trigger: 'blur'
            },
            { max: 10, message: '长度在10个字符', trigger: 'blur' }
        ],
        onWayContactPhone: [
            {
                required: true,
                message: '请输入在途联系人电话',
                trigger: 'blur'
            },
            { pattern: /^1[3-9](\d{9})$/, message: '请输入正确的手机号', trigger: ['change'] },
            { max: 11, message: '请输入11位手机号', trigger: 'change' }
        ],
        transUnitName: [
            {
                required: true,
                message: '下游会计主体不能为空',
                trigger: ['blur', 'change']
            }
        ],
        ztbTransportFlag: [
            { required: true, message: '请选择是否直通宝转运', trigger: 'change' }
        ],
         multiPackagesShipment: [
            {
                required: true,
                message: '是否拆子母件不能为空',
                trigger: ['change']
            }
        ],
    }
};
